import { Box, FormControl, TextFieldSize } from '@bechtel/gds';
import { Facility, FacilityUnitRate } from '@bechtel/types';
import { Field } from 'formik';
import { get, map } from 'lodash';
import React from 'react';
import { useAppUser, ErrorRetry } from '@bechtel/client-common';
import { useProjectFacilityQuery } from '~/user-admin/hooks/use-facility';
import { TextInputStyled } from '../styled';
import { t, Trans } from '@lingui/macro';

export const FacilityList = () => {
  const { user } = useAppUser();
  const {
    loading: facilityLoading,
    error: facilityError,
    data: facilityData,
    refetch: facilityRefetch,
  } = useProjectFacilityQuery(user?.project?.id ? user.project.id : '');
  const facilityUnitRateList: FacilityUnitRate[] = get(facilityData, 'projectConfigById.facilityUnitRates', []);
  const facilityList: Facility[] = map(facilityUnitRateList, (facilityUnitRate) => facilityUnitRate.facility);

  return (
    <>
      {!facilityLoading && facilityError && (
        <ErrorRetry refetch={facilityRefetch}>
          <Trans>There was a problem loading facility list. Please click the button below to try again.</Trans>
        </ErrorRetry>
      )}

      {!facilityError &&
        facilityList.map((facility, index) => {
          return (
            <Box key={index} my={{ sm: '500' }} flexGrow={{ sm: '1' }} data-testid="facility">
              <FormControl
                label={facility.name + t`(hours/foot)`}
                css={`
                  flex-grow: 1;
                `}
              >
                <Field name={`facilitiesUnitRate[${index}].unitRate.unitRate`}>
                  {({ field }) => {
                    return (
                      <TextInputStyled type="number" size={TextFieldSize.LARGE} {...field} placeholder={t`Area`} />
                    );
                  }}
                </Field>
              </FormControl>
            </Box>
          );
        })}
    </>
  );
};
